<template>
  <div class="news-message-manage-page">
    <div class="news-message-manage-page__header">
      <h2 class="news-message-manage-page__title">下单消息管理</h2>
      <p class="news-message-manage-page__desc">管理各场景的下单消息，支持查看详情、回复等操作</p>
    </div>

    <div class="toolbar-card">
      <div class="toolbar-card__left">
        <el-input
            v-model="params.newsId"
            class="toolbar-card__input"
            clearable
            placeholder="企业ID"
            style="width: 150px"
            type="number"
        />
        <el-select
            v-model="params.adminIsRead"
            class="toolbar-card__select"
            clearable
            placeholder="是否已读"
            style="width: 120px"
        >
          <el-option
              v-for="item in adminIsReads"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
        <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button icon="el-icon-delete" @click="flush">清空</el-button>
      </div>
    </div>

    <div class="main-card">
      <div class="table-wrap">
        <el-table v-loading="loadTable" :data="records" size="small" stripe>
          <el-table-column fixed label="企业ID" prop="newsId" width="100"/>
          <el-table-column label="企业标题" min-width="150" prop="title" show-overflow-tooltip/>
          <el-table-column align="center" label="封面" width="80">
            <template slot-scope="scope">
              <el-image
                  :preview-src-list="scope.row.coverImg"
                  :src="scope.row.coverImg[0]"
                  class="cover-thumb"
                  fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="微信昵称" min-width="120" prop="nickName" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.nickName || '未填写' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="名片名称" min-width="120" prop="nameCardName" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.nameCardName || '未填写' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="解禁时间" min-width="160" prop="stopMessageDate" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ formatStopDate(scope.row.stopMessageDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" min-width="160" prop="createdTime" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime || '未填写' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="详情" min-width="100" prop="content" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ formatContent(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户读状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.userIsReadReply === '0' ? 'info' : 'success'" size="mini">
                {{ scope.row.userIsReadReply === '0' ? '未读' : '已读' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button icon="el-icon-more" plain size="mini" type="primary">操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.hiddenMessage === '0'" :command="{action: 'content', row: scope.row}">
                    <i class="el-icon-view"/> 查看详情
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.adminIsRead === '0'" :command="{action: 'read', row: scope.row, value: '1'}">
                    <i class="el-icon-check"/> 标记已读
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.adminIsRead === '1'" :command="{action: 'read', row: scope.row, value: '0'}">
                    <i class="el-icon-close"/> 标记未读
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.hiddenMessage === '1'" :command="{action: 'show', row: scope.row}">
                    <i class="el-icon-view"/> 显示下单
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.hiddenMessage === '0'" :command="{action: 'hide', row: scope.row}">
                    <i class="el-icon-hide"/> 隐藏下单
                  </el-dropdown-item>
                  <el-dropdown-item :command="{action: 'reply', row: scope.row}">
                    <i class="el-icon-chat-dot-round"/> 回复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>


    <!--  下单详情  -->
    <NewsMessageContentDialog
        :visible.sync="showContent"
        :row="contentRow"
        :file-base-url="fileBaseUrl"
    />


    <!--    禁用用户下单提示框-->
    <el-dialog
        title="提示"
        :visible.sync="showStopMessage"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="stopMessage">
        <el-form-item label="禁用天数">
          <el-input v-model="stopMessage.days" placeholder="请输入整数"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showStopMessage = false">取 消</el-button>
        <el-button type="primary" @click="doStopMessage">确 定</el-button>
      </span>
    </el-dialog>


    <!--    管理员回复下单框-->
    <el-dialog
        title="回复"
        :visible.sync="showReplyMessage"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="replyMessage">
        <el-form-item label="回复下单">
          <el-input
              type="textarea"
              autosize
              placeholder="请输入内容"
              v-model="replyMessage.reply">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showReplyMessage = false">取 消</el-button>
        <el-button type="primary" @click="doReplyMessage">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>


import Page from "@/components/Page";
import NewsMessageContentDialog from "@/components/NewsMessage/NewsMessageContentDialog.vue";
import adminGetNewsMessage from "@/api/user/admin-controler/adminGetNewsMessage";
import {Message} from "element-ui";
import adminStopMessage from "@/api/user/admin-controler/adminStopMessage";
import adminOpenHiddenMessage from "@/api/user/admin-controler/adminOpenHiddenMessage";
import adminReadMessage from "@/api/user/admin-controler/adminReadMessage";
import adminReplyMessage from "@/api/user/admin-controler/adminReplyMessage";

export default {
  name: "NewsMessageManage",
  components: {Page, NewsMessageContentDialog},
  data() {
    return {
      current:1,
      size:10,
      total: 0,

      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      params: {
        newsId: localStorage.getItem("newsId"),
        adminIsRead: undefined
      },
      adminIsReads: [
        {
          value: 1,
          label: '已读'
        },
        {
          value: 0,
          label: '未读'
        },
      ],

      loadTable: false,
      records: [],

      showContent: false,
      contentRow: null,

      showStopMessage: false,
      stopMessage: {
        days: undefined,
        wechatMpId: undefined,
      },

      showReplyMessage: false,
      replyMessage: {
        id: undefined,
        reply: undefined
      },

    }
  },

  methods: {
    // 格式化解禁时间
    formatStopDate(date) {
      if (!date) return '无'
      return new Date(date).getTime() > new Date().getTime() ? date : '无'
    },
    // 格式化内容显示
    formatContent(row) {
      if (row.hiddenMessage === '1') return '已屏蔽'
      if (!row.content) return ''
      return row.content.length > 8 ? '...' : row.content
    },
    // 处理下拉菜单命令
    handleCommand(command) {
      const {action, row, value} = command
      switch (action) {
        case 'content':
          this.onShowContent(row)
          break
        case 'read':
          this.adminReadMessage(row, value)
          break
        case 'show':
          this.onOpenHiddenMessage(row, '0')
          break
        case 'hide':
          this.onOpenHiddenMessage(row, '1')
          break
        case 'reply':
          this.onReplyMessage(row)
          break
      }
    },
    doReplyMessage(){
      adminReplyMessage(this.replyMessage).then(res=>{
        if(res.code==1){
          Message({
            message:"成功",
            type:"success",
            duration:3000
          })
          this.showReplyMessage = false
          this.fetchData()
        }else{
          if(res.data && res.data.reply){
            Message({
              message:res.data.reply,
              type:"error",
              duration:3000
            })
          }
        }
      })
    },
    adminReadMessage(row, adminIsRead){
      adminReadMessage(row.id, adminIsRead).then(res=>{
        if(res.code==1){
          Message({
            message:'成功',
            type:"success",
            duration:3000
          })
          this.fetchData()
        }
      })
    },
    onShowContent(row){
      this.contentRow = row
      this.showContent = true
    },
    onReplyMessage(row){
      this.replyMessage = {
        id: row.id,
        reply: row.reply
      }
      this.showReplyMessage = true
    },

    onOpenHiddenMessage(row, hiddenMessage){
      adminOpenHiddenMessage(row.id, hiddenMessage).then(res=>{
        if(res.code==1){
          Message({
            message: "成功",
            type: "success",
            duration: 3 * 1000
          })
          this.fetchData()
        }
      })
    },

    onShowStopMessage(row){
      this.stopMessage.wechatMpId = row.wechatMpId
      this.showStopMessage  = true
    },
    doStopMessage(){
      if(!this.stopMessage.days){
        return Message({
          message: "请输入禁用天数",
          type: "error",
          duration: 3 * 1000
        })
      }
      if(isNaN(parseInt(this.stopMessage.days))) {
        return Message({
          message: "请输入整数",
          type: "error",
          duration: 3 * 1000
        })
      }
      if(this.stopMessage.days<0) {
        return Message({
          message: "禁用天数至少为0",
          type: "error",
          duration: 3 * 1000
        })
      }

      adminStopMessage(this.stopMessage.wechatMpId, parseInt(this.stopMessage.days)).then(res=>{
        if(res.code==1) {
          Message({
            message: "成功",
            type: "success",
            duration: 3 * 1000
          })
          this.showStopMessage = false
          this.fetchData()
        }
      })

    },
    search(){
      this.current=1
      this.size=10
      this.fetchData()
    },

    reset(){
      this.current=1
      this.size=10
      this.params = {
        newsId: localStorage.getItem("newsId"),
      }
      this.fetchData()
    },
    flush(){
      this.current=1
      this.size=10
      this.params = {}
      localStorage.removeItem("newsId")
      this.fetchData()
    },
    fetchData(){
      adminGetNewsMessage(this.current, this.size, this.params).then(res=>{
        let data = res.data.data
        for (let i = 0; i < data.length; i++) {
          if(data[i].coverImg){
            data[i].coverImg = [this.fileBaseUrl+data[i].coverImg]
          }else {
            data[i].coverImg = ['https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132']
          }
        }
        this.records = data
        this.total = res.data.total
      })
    },
  },

  mounted() {
    let promulgatorId = localStorage.getItem("promulgatorId")
    if(promulgatorId){
      this.params.adminIsRead=0
      localStorage.removeItem("promulgatorId")
    }
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.news-message-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;

  &__header {
    margin-bottom: 16px;
    padding: 0 4px;
  }

  &__title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
  }

  &__desc {
    margin: 6px 0 0;
    font-size: 13px;
    color: #9ca3af;
  }
}

.toolbar-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px 20px;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  &__input,
  &__select {
    ::v-deep .el-input__inner {
      border-radius: 6px;
    }
  }
}

.main-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.table-wrap {
  padding: 0 0 4px;
}

.cover-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #eef0f3;
  cursor: pointer;
}

.pagination-wrap {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 768px) {
  .news-message-manage-page {
    padding: 12px;
  }

  .toolbar-card {
    flex-direction: column;
    align-items: stretch;

    &__left {
      flex-wrap: wrap;
    }
  }
}
</style>
